import React, {useEffect, useState} from 'react'
import VideoUploader from '../VideoUploader'
import LoadingOverlay from 'react-loading-overlay'
import axios from 'axios'

function VideoBanner(props) {
  const [spinnerIsActive, setSpinnerIsActive] = useState(false)
  const [inputTitle, setInputTitle] = useState('')
  const [inputDesc, setInputDesc] = useState('')
  const [videoInfo, setVideoInfo] = useState('')
  const [checkTitle, setCheckTitle] = useState(false)
  const [checkDesc, setCheckDesc] = useState(false)

  const [showAlertSuccess, setShowAlertSuccess] = useState(false)

  const url = 'https://puntosurgdl.com/backend/'

  useEffect(() => {
    getVideoInfo()
  }, [])

  const getVideoInfo = () => {
    axios.get(url + 'getVideoInfo.php').then(function (response) {
      setVideoInfo(response.data.data[0])

      // Video Reload
      const videoElement = document.getElementById('home-video-fondo')
      const sourceElement = document.createElement('source')
      sourceElement.setAttribute('id', 'home-video-fondo-source')
      sourceElement.setAttribute('src', response.data.data[0].url)
      videoElement.appendChild(sourceElement)

      console.log(response.data.data[0])

      setCheckTitle(response.data.data[0].titleIsActive)
      setCheckDesc(response.data.data[0].descIsActive)
    })
  }

  const onChangeTitle = (event) => {
    setInputTitle(event.target.value)
  }

  const onChangeDesc = (event) => {
    setInputDesc(event.target.value)
  }

  const onChangeCheckTitle = (event) => {
    if (event.target.checked) {
      console.log('is checked')
    } else {
      console.log('is NOT checked')
    }

    setCheckTitle((current) => !current)
  }

  const onChangeCheckDesc = (event) => {
    if (event.target.checked) {
      console.log('is checked')
    } else {
      console.log('is NOT checked')
    }

    setCheckDesc((current) => !current)
  }

  const funSpinnerIsActive = (valueState) => {
    setSpinnerIsActive(valueState)
  }

  const onSubmit = () => {
    setSpinnerIsActive(true)

    const dataForm = {
      name: 'home-video-fondo',
      title: document.getElementById('titulo-video').value,
      titleIsActive: checkTitle,
      description: document.getElementById('descripcion-video').value,
      descIsActive: checkDesc,
    }

    console.log(dataForm)

    axios
      .post(url + 'saveVideoDetails.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          setSpinnerIsActive(false)
          setShowAlertSuccess(true)

          setTimeout(function () {
            setShowAlertSuccess(false)
          }, 3000)
        },
        (error) => {
          alert(error)
          setSpinnerIsActive(false)
        }
      )
  }

  return (
    <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
      {showAlertSuccess ? (
        <div className='alert alert-success alert-dismissible bg-success d-flex flex-column flex-sm-row p-5 mb-10'>
          <span className='svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              class='mh-50px'
            >
              <path
                opacity='0.3'
                d='M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z'
                fill='black'
              ></path>
              <path
                d='M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z'
                fill='black'
              ></path>
            </svg>
          </span>
          <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
            <h3 className='mb-1'>Cambios guardados con éxito</h3>
          </div>
        </div>
      ) : (
        <div></div>
      )}{' '}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Video de banner</h3>
            <h5 className='card-subtitle'>
              Subir un archivo .mp4, idealmente de 20 segundos, que no pese más de 40MB de peso
            </h5>
          </div>
          <div className='card-body'>
            <p>Video Actual</p>
            <video id='home-video-fondo' controls>
              {/* <source id='home-video-fondo-source' src={videoInfo.fullUrl} /> */}
              Tu navegador no soporta la tag video.
            </video>

            <label className='form-label mt-4'>Título</label>
            <input
              id='titulo-video'
              name='titulo-video'
              className='form-control'
              type='text'
              defaultValue={videoInfo.title}
              onChange={(e) => onChangeTitle(e)}
            />
            <div className='form-check form-switch form-check-custom form-check-solid mt-8 title-active-check'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={checkTitle}
                onChange={(e) => onChangeCheckTitle(e)}
                id='title-active'
              />
              <label className='form-check-label' for='title-active'>
                Ocultar título del video
              </label>
            </div>

            <label className='form-label mt-1'>Subtítulo</label>
            <input
              id='descripcion-video'
              name='descripcion-concepto'
              className='form-control'
              type='text'
              defaultValue={videoInfo.description}
              onChange={(e) => onChangeDesc(e)}
            />
            <div className='form-check form-switch form-check-custom form-check-solid mt-8'>
              <input
                className='form-check-input desc-active'
                type='checkbox'
                checked={checkDesc}
                onChange={(e) => onChangeCheckDesc(e)}
                id='desc-active'
              />
              <label className='form-check-label' for='desc-active'>
                Ocultar subtítulo del video
              </label>
            </div>

            <VideoUploader name='home-video-fondo' setSpinnerIsActive={setSpinnerIsActive} />
          </div>
          <div className='card-footer'>
            <div className='form-group float-end'>
              <button type='submit' className='btn btn-primary mt-6' onClick={() => onSubmit()}>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}

export {VideoBanner}
